import { Breakpoint, Color } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media ${Breakpoint.Tablet} {
    flex-direction: row;
    padding: 0 0 0;
  }
`;

export const VideoContainer = styled.div`
  width: 100%;

  @media ${Breakpoint.Tablet} {
    width: 56%;
    margin-top: 0;
  }
`;

export const TextContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: ${Color.White};
  padding: 32px 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding: 32px;
  }
`;

export const HeadlineContainer = styled.div`
  border-bottom: 2px solid ${Color.Brand300};
  padding-bottom: 15px;
`;
